import { Grid2, Skeleton } from "@mui/material";
import SubscriptionCard from "@shop/components/SubscriptionCard";
import React from "react";
import { updateSelectedProduct, useShopSlice, markUnsavedChanges } from "@store/slices/shop";
import { useDispatch } from "react-redux";
import { State } from "@store/state";

const features = {
    QW: ["KI-gestützte doppelte Wesentlichkeitsanalyse", "KI-gestützte IRO-Generierung für alle Subtopics"],
    VSME: ["KI-gestützer VSME Report"],
};

const AIServiceSelection = () => {
    const dispatch = useDispatch();
    const { products, selectedProducts } = useShopSlice();

    const p1 = products.find((product: State.Product) => product.name.includes("Wesentlichkeit"));
    const p2 = products.find((product: State.Product) => product.name.includes("Report"));

    // Get current quantity for a price ID from selected products
    const getCurrentQuantity = (priceId: string) => {
        const selected = selectedProducts.find((p: any) => p.priceId === priceId);
        return selected?.quantity || 0;
    };

    const handleQuantityChange = (quantity: number, priceId: string) => {
        if (!priceId) return;

        dispatch(updateSelectedProduct({ priceId, quantity }));
        // Markiere Änderungen als ungespeichert für Auto-Save
        dispatch(markUnsavedChanges());
    };

    // Show loading skeletons only during initial load (when products array is empty)
    if (products.length === 0) {
        return (
            <Grid2 container size={12} spacing={3} justifyContent={"center"}>
                <Grid2>
                    <Skeleton variant="rectangular" width={260} height={360} sx={{ borderRadius: 2 }} />
                </Grid2>
                <Grid2>
                    <Skeleton variant="rectangular" width={260} height={360} sx={{ borderRadius: 2 }} />
                </Grid2>
            </Grid2>
        );
    }

    return (
        <Grid2 container size={12} spacing={3} justifyContent={"center"}>
            <Grid2>
                <SubscriptionCard
                    title={"Quick-Wesentlichkeitsanalyse"}
                    monthlyPrice={(p1?.prices?.[0]?.amount || 0) / 100}
                    features={features["QW"]}
                    productType="SERVICE_CREDIT"
                    useGradient={true}
                    priceInterval={p1?.prices?.[0]?.interval}
                    priceId={p1?.prices?.[0]?.priceId}
                    onQuantityChange={(quantity) => handleQuantityChange(quantity, p1?.prices?.[0]?.priceId || "")}
                    initialQuantity={getCurrentQuantity(p1?.prices?.[0]?.priceId || "")}
                />
            </Grid2>

            <Grid2>
                <SubscriptionCard
                    title={"VSME-Report-Generator"}
                    monthlyPrice={(p2?.prices?.[0]?.amount || 0) / 100}
                    features={features["VSME"]}
                    productType="SERVICE_CREDIT"
                    useGradient={true}
                    priceInterval={p2?.prices?.[0]?.interval}
                    priceId={p2?.prices?.[0]?.priceId}
                    onQuantityChange={(quantity) => handleQuantityChange(quantity, p2?.prices?.[0]?.priceId || "")}
                    initialQuantity={getCurrentQuantity(p2?.prices?.[0]?.priceId || "")}
                />
            </Grid2>
        </Grid2>
    );
};

export default AIServiceSelection;
